import type { NormalizedCacheObject } from 'apollo-cache-inmemory';
import type ApolloClient from 'apollo-client';
import { clientCreator } from '../gateway';

let apolloClient: ApolloClient<NormalizedCacheObject>;

export const getApolloClient = () => {
    if (!apolloClient) {
        apolloClient = clientCreator();
    }
    return apolloClient;
};
